<script setup lang="ts">
import BrokerAvatar from '@/components/BrokerAvatar/BrokerAvatar.vue';
import { cn } from '@/utils';
import type { BrokerAvatarInfoProps } from '.';

const props = withDefaults(defineProps<BrokerAvatarInfoProps>(), {
	showCompanyAvatar: true,
	brokerSrc: '/images/fallbacks/agent-avatar.svg',
	companySrc: '/images/fallbacks/company-avatar.svg'
});
</script>

<template>
	<div :class="cn('flex flex-row items-center', props.class)">
		<BrokerAvatar
			:class="props.avatarClass"
			:avatar-shape="avatarShape"
			:company-avatar-shape="companyAvatarShape"
			:border="border"
			:sizes="sizes"
			:is-grayscale="isGrayscale"
			:show-company-avatar="showCompanyAvatar"
			:broker-src="brokerSrc || '/images/fallbacks/agent-avatar.svg'"
			:company-src="companySrc || '/images/fallbacks/company-avatar.svg'"
		/>

		<div
			:class="
				cn(
					'xl:max-w-fill-available flex w-auto max-w-[100%] flex-col',
					props.infoClasses?.wrapper
				)
			"
		>
			<p
				:class="
					cn(
						'w-auto truncate text-nowrap leading-[20px]',
						props.infoClasses?.brokerName
					)
				"
			>
				<slot name="broker"></slot>
			</p>
			<small
				:class="
					cn(
						'w-auto truncate text-nowrap leading-[18px]',
						props.infoClasses?.companyName
					)
				"
			>
				<slot name="company"></slot>
			</small>
		</div>

		<slot></slot>
	</div>
</template>

<style lang="scss" scoped>
@screen xl {
	.xl\:max-w-fill-available {
		max-width: -webkit-fill-available;
	}
}
</style>
